import { Pressable } from "react-native";
import {
  useUser,
  useUserOfflineUpdate,
  useUserOnlineUpdate,
} from "../services";
import { OnlineIndicator } from "./online-indicator";
import { useCallback, useEffect, useState } from "react";

export function UserOnlineIndicator() {
  // Data
  const { data: user, isLoading: isLoadingUser } = useUser();
  const [goOnline, isUpdatingOnline] = useUserOnlineUpdate();
  const [goOffline, isUpdatingOffline] = useUserOfflineUpdate();

  // State
  const [isOnline, setOnline] = useState<boolean | null>(null);

  // Vars
  const isLoading =
    isOnline === null || isLoadingUser || isUpdatingOnline || isUpdatingOffline;

  // Methods
  const toggleOnline = useCallback(async () => {
    if (user?.online) {
      await goOffline();
      setOnline(false);
    } else {
      await goOnline();
      setOnline(true);
    }
  }, [goOffline, goOnline, user?.online]);

  // Effects
  useEffect(() => {
    if (typeof user?.online !== "undefined") {
      setOnline(user.online);
    }
  }, [user?.online]);

  // Render
  return (
    <Pressable onPress={toggleOnline}>
      <OnlineIndicator value={isOnline ?? false} loading={isLoading} />
    </Pressable>
  );
}
